function getRegionPlanId(plan ="business") {
    const region = window._CLIENT_REGION;
    if(plan.indexOf("basic") > - 1) {
        if(!!region && ["KH", "UK", "US", "VI", "JP"].indexOf(region) > -1) {
            return "MORNING_BASIC_" + region.toUpperCase() + "_A";
        } else {
            return "MORNING_BASIC_ETC_A";
        }
    } else {
        if(!!region && ["UK", "US"].contains(region) > -1) {
            return "MORNING_BUSINESS_" + region.toUpperCase() + "_B";
        } else if ( region === "JP" ) {
            return "MORNING_BASIC_JP_A";
        } else {
            return "MORNING_BUSINESS_ETC_B";
        }
    }
}

export {getRegionPlanId}